class QuantitySelector extends HTMLElement {
	constructor() {
		super()

		this.quantityInput = this.querySelector('input[type="number"]')
		this.quantityIncreaseButton = this.querySelector('button[name="plus"]')
		this.quantityDecreaseButton = this.querySelector('button[name="minus"]')
	}

	connectedCallback() {
		this.quantityInput.addEventListener("change", () => {
			this.onQuantityChange()
		})

		this.quantityIncreaseButton.addEventListener("click", event => {
			event.preventDefault()
			this.quantityInput.stepUp()
			this.onQuantityChange()
		})

		this.quantityDecreaseButton.addEventListener("click", event => {
			event.preventDefault()
			this.quantityInput.stepDown()
			this.onQuantityChange()
		})
	}

	DisableAll() {
		this.quantityIncreaseButton.disabled = true
		this.quantityDecreaseButton.disabled = true
		this.quantityInput.disabled = true
	}

	EnableAll() {
		this.quantityIncreaseButton.disabled = false
		this.quantityDecreaseButton.disabled = false
		this.quantityInput.disabled = false
	}

	/**
	 * Handles the quantity change event.
	 */
	async onQuantityChange() {
		this.DisableAll()
		this.dispatchEvent(
			new CustomEvent("quantity-change", {
				detail: {
					value: Number(this.quantityInput.value),
					line: this.quantityInput.dataset.cartLine,
					variant: this.quantityInput.dataset.variantId,
				},
				bubbles: true,
				composed: true,
			})
		)

		const cartChangeRequest = await fetch("/cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				line: this.quantityInput.dataset.cartLine,
				quantity: this.quantityInput.value,
				sections: "cart-drawer",
			}),
		}).then(res => res.json())

		// check for Shopify error statuses (like 422)
		if (!cartChangeRequest?.items) {
			const message = cartChangeRequest.description || cartChangeRequest.message || "Cart update failed."
			this.dispatchEvent(
				new CustomEvent("quantity-change-done", {
					detail: {
						message,
						error: true,
						cartChangeRequest,
						value: Number(this.quantityInput.value),
						line: this.quantityInput.dataset.cartLine,
						variant: this.quantityInput.dataset.variantId,
					},
					bubbles: true,
					composed: true,
				})
			)
			this.EnableAll()
			return
		}

		this.dispatchEvent(
			new CustomEvent("quantity-change-done", {
				detail: {
					cartChangeRequest,
					value: Number(this.quantityInput.value),
					line: this.quantityInput.dataset.cartLine,
					variant: this.quantityInput.dataset.variantId,
				},
				bubbles: true,
				composed: true,
			})
		)
		this.EnableAll()
	}
}
customElements.define("quantity-selector-component", QuantitySelector)
